import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';
import { AuthGuard } from './_guards/auth.guard';
import { RegisterComponent } from './register';
import { LoginComponent } from './login';
import { ChangelogComponent } from './changelog/changelog.component';
import { EditLabelComponent } from './changelog/editlabel/editlabel.component';
import { LabeldetailComponent } from './changelog/labeldetail/labeldetail.component';
import { PromptsComponent } from './prompts/prompts.component';
import { MustahzarComponent } from './mustahzar/mustahzar.component';
import { FirmalarComponent } from './firmalar/firmalar.component';
import { FirmaMustahzarComponent } from './firmalar/firma-mustahzar/firma-mustahzar.component';
import { LoginwithlinkComponent } from './login/loginwithlink/loginwithlink.component';
import { SutComponent } from './sut/sut.component';
import { SutListeComponent } from './sut/sut-liste/sut-liste.component';
import { FormRunnerComponent } from './sutmotor/form-runner/form-runner.component';

const appRoutes: Routes = [
  // Public layout
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      { path: 'loginwithlink/:link', component: LoginwithlinkComponent },
      { path: '', component: LoginComponent }
    ]
  },
  // Private layout
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      { path: 'logout', component: LoginComponent, canActivate: [AuthGuard] },
      { path: 'panel', component: ChangelogComponent, canActivate: [AuthGuard] },
      { path: 'detay/:id', component: LabeldetailComponent, canActivate: [AuthGuard] },
      { path: 'prompts', component: PromptsComponent, canActivate: [AuthGuard] },
      { path: 'mustahzar', component: MustahzarComponent, canActivate: [AuthGuard] },
      { path: 'firmalar', component: FirmalarComponent, canActivate: [AuthGuard] },
      { path: 'firmamustahzar/:id', component: FirmaMustahzarComponent, canActivate: [AuthGuard] },
         { path: 'sut/:id', component: SutComponent, canActivate: [AuthGuard] },
         { path: 'sutliste', component: FormRunnerComponent, canActivate: [AuthGuard] },
    ],
  },
  // otherwise redirect to home
  { path: '**', redirectTo: 'panel' }
];

export const routing = RouterModule.forRoot(appRoutes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top'});
